<template>
    <div slot="content">

    </div>
</template>

<script>
export default {
    data() {
        return {
            data: [{test2 : 'test3'}]
        }
    },
    methods: {

    }
}
</script>